export default "__VITE_ASSET__DAISGgtl__"